import { createSlice } from "@reduxjs/toolkit"

const currencySlice = createSlice({
  name: "currency",
  initialState: {
    value: "usd"
  },
  reducers: {
    setcurrency: (state, action) => {
      state.value = action.payload
    }
  }
})

export const { setcurrency } = currencySlice.actions

export default currencySlice.reducer
